(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9742],{

/***/ 27627:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/forgot-password",
      function () {
        return __webpack_require__(66762);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 15601:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "h": function() { return /* binding */ Header; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 2 modules
var styled_components_browser_esm = __webpack_require__(186);
;// CONCATENATED MODULE: ./src/modules/auth/components/Header/styles.ts

function _templateObject() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  display: flex;\n  align-items: center;\n  flex-direction: column;\n\n  margin-bottom: ",
        ";\n  margin-top: -",
        ";\n\n  h2 {\n    color: ",
        ";\n    font-weight: 700;\n    font-size: 30px;\n    font-weight: 700;\n    text-align: center;\n\n    & + p {\n      margin-top: ",
        ";\n    }\n  }\n\n  p {\n    color: ",
        ";\n    font-size: 16px;\n    text-align: center;\n    line-height: 24px;\n  }\n"
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}

const Container = styled_components_browser_esm/* default.header.withConfig */.ZP.header.withConfig({
    componentId: "sc-a26e7196-0"
})(_templateObject(), (param)=>{
    let { theme  } = param;
    return theme.spacing.xs;
}, (param)=>{
    let { theme  } = param;
    return theme.spacing.lg;
}, (param)=>{
    let { theme  } = param;
    return theme.colors.primary;
}, (param)=>{
    let { theme  } = param;
    return theme.spacing.xxs;
}, (param)=>{
    let { theme  } = param;
    return theme.colors.onSurface;
});

;// CONCATENATED MODULE: ./src/modules/auth/components/Header/index.tsx



const Header = (param)=>{
    let { title , subtitle , extraSubtitle  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container, {
        children: [
            !!title && /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                children: title
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                children: subtitle.split("\n").map((line)=>/*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
                        children: [
                            line,
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {})
                        ]
                    }, line))
            }),
            extraSubtitle && /*#__PURE__*/ (0,jsx_runtime.jsx)("small", {
                children: extraSubtitle
            })
        ]
    });
};


/***/ }),

/***/ 77879:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "r": function() { return /* binding */ Link; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 2 modules
var styled_components_browser_esm = __webpack_require__(186);
;// CONCATENATED MODULE: ./src/modules/auth/components/Link/styles.ts

function _templateObject() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n  margin-right: auto;\n\n  color: ",
        ";\n\n  transition: all 0.3s;\n\n  span {\n    font-size: 14px;\n    font-weight: 600;\n\n    > * {\n      color: ",
        ";\n    }\n  }\n\n  svg {\n    margin-right: ",
        ";\n    height: 18px;\n    width: 18px;\n  }\n\n  &:hover {\n    opacity: 0.7;\n  }\n\n  & + a,\n  & + button {\n    margin-top: ",
        ";\n  }\n"
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}


const Container = (0,styled_components_browser_esm/* default */.ZP)((link_default())).withConfig({
    componentId: "sc-a2acc475-0"
})(_templateObject(), (param)=>{
    let { theme  } = param;
    return theme.colors.secondary;
}, (param)=>{
    let { theme  } = param;
    return theme.colors.secondary;
}, (param)=>{
    let { theme  } = param;
    return theme.spacing.xs;
}, (param)=>{
    let { theme  } = param;
    return theme.spacing.sm;
});

;// CONCATENATED MODULE: ./src/modules/auth/components/Link/index.tsx


const Link = (param)=>{
    let { title , icon: Icon , href , target , rel , customContent , ...props } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container, {
        href: href,
        passHref: true,
        ...props,
        target: target,
        rel: rel,
        children: [
            !!Icon && /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon, {}),
            customContent || /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                children: title
            })
        ]
    });
};


/***/ }),

/***/ 66762:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSP": function() { return /* binding */ __N_SSP; },
  "default": function() { return /* binding */ forgot_password; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-icons/io5/index.mjs
var io5 = __webpack_require__(18318);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/yup/es/index.js + 25 modules
var es = __webpack_require__(74231);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/react/node_modules/@chakra-ui/toast/dist/chunk-JFERWNZE.mjs
var chunk_JFERWNZE = __webpack_require__(9691);
// EXTERNAL MODULE: ./src/shared/utils/masks.ts
var masks = __webpack_require__(33613);
// EXTERNAL MODULE: ./src/shared/constants/routes.ts
var routes = __webpack_require__(224);
// EXTERNAL MODULE: ./src/shared/components/Form/Input/index.tsx
var Input = __webpack_require__(72169);
// EXTERNAL MODULE: ./src/shared/components/Form/FormGroup/index.tsx + 1 modules
var FormGroup = __webpack_require__(24293);
// EXTERNAL MODULE: ./src/shared/components/Form/Button/index.tsx + 1 modules
var Button = __webpack_require__(52409);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 2 modules
var styled_components_browser_esm = __webpack_require__(186);
;// CONCATENATED MODULE: ./src/modules/auth/pages/ForgotPassword/styles.ts

function _templateObject() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n"
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}

const AccountRecoveryOptions = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-9a4b4d51-0"
})(_templateObject());

// EXTERNAL MODULE: ./src/modules/auth/hooks/auth.tsx + 1 modules
var auth = __webpack_require__(30317);
// EXTERNAL MODULE: ./src/modules/auth/components/Link/index.tsx + 1 modules
var Link = __webpack_require__(77879);
// EXTERNAL MODULE: ./src/modules/auth/components/Header/index.tsx + 1 modules
var Header = __webpack_require__(15601);
;// CONCATENATED MODULE: ./src/modules/auth/components/ButtonLink/styles.ts

function styles_templateObject() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n  margin-right: auto;\n\n  color: ",
        ";\n\n  transition: all 0.3s;\n\n  span {\n    font-size: 14px;\n    font-weight: 600;\n  }\n\n  svg {\n    margin-right: ",
        ";\n    height: 18px;\n    width: 18px;\n  }\n\n  &:hover {\n    opacity: 0.7;\n  }\n\n  & + a,\n  & + button {\n    margin-top: ",
        ";\n  }\n"
    ]);
    styles_templateObject = function() {
        return data;
    };
    return data;
}

const Container = styled_components_browser_esm/* default.button.withConfig */.ZP.button.withConfig({
    componentId: "sc-ffbf5a68-0"
})(styles_templateObject(), (param)=>{
    let { theme  } = param;
    return theme.colors.secondary;
}, (param)=>{
    let { theme  } = param;
    return theme.spacing.xs;
}, (param)=>{
    let { theme  } = param;
    return theme.spacing.sm;
});

;// CONCATENATED MODULE: ./src/modules/auth/components/ButtonLink/index.tsx


const ButtonLink = (param)=>{
    let { title , icon: Icon , ...props } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container, {
        ...props,
        children: [
            !!Icon && /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                children: title
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/modules/auth/pages/ForgotPassword/index.tsx
















const ForgotPassword = ()=>{
    const { sendRecoveryAccountLink  } = (0,auth/* useAuth */.aC)();
    const toast = (0,chunk_JFERWNZE/* useToast */.p)();
    const router = (0,next_router.useRouter)();
    const [accountRecoveryOption, setAccountRecoveryOption] = (0,react.useState)(null);
    const [inputOptions, setInputOptions] = (0,react.useState)({});
    const [inputValue, setInputValue] = (0,react.useState)("");
    const [inputError, setInputError] = (0,react.useState)("");
    const [isRecoveringAccount, setIsRecoveringAccount] = (0,react.useState)(false);
    function handleSelectAccountRecoveryOption(option) {
        setAccountRecoveryOption(option);
        switch(option){
            case "email":
                setInputOptions({
                    placeholder: "Digite seu e-mail",
                    name: "email",
                    autoComplete: "email",
                    startIcon: io5/* IoMailOutline */.WNJ
                });
                break;
            case "sms":
                setInputOptions({
                    name: "sms",
                    placeholder: "Digite seu n\xfamero de celular",
                    autoComplete: "tel",
                    maxLength: 16,
                    startIcon: io5/* IoPhonePortraitOutline */.T1V
                });
                break;
            case "whatsapp":
                setInputOptions({
                    name: "whatsapp",
                    placeholder: "Digite seu n\xfamero de celular",
                    autoComplete: "tel",
                    startIcon: io5/* IoLogoWhatsapp */.ff9,
                    maxLength: 16
                });
                break;
            default:
                break;
        }
    }
    function handleChangeAccountRecoveryOption() {
        setAccountRecoveryOption(null);
        setInputValue("");
        setInputOptions({});
    }
    function handleChangeInput(event) {
        const { value  } = event.target;
        let newValue = value;
        if (accountRecoveryOption !== "email") {
            newValue = (0,masks/* unmask */.ec)(newValue);
        }
        setInputError("");
        setInputValue(newValue);
    }
    async function handleRecoveryAccount(event) {
        event.preventDefault();
        if (!accountRecoveryOption) return;
        try {
            setIsRecoveringAccount(true);
            if (accountRecoveryOption === "email") {
                await es/* string */.Z_().email("e-mail inv\xe1lido").required("e-mail \xe9 obrigat\xf3rio").validate(inputValue);
            } else {
                await es/* string */.Z_().required("n\xfamero de celular \xe9 obrigat\xf3rio").validate(inputValue);
            }
            await sendRecoveryAccountLink({
                option: accountRecoveryOption,
                value: inputValue
            });
            let description = "Abra o link que enviamos por SMS.";
            if (accountRecoveryOption === "email") {
                description = "Abra o link que enviamos no seu e-mail.";
            }
            if (accountRecoveryOption === "whatsapp") {
                description = "Abra o link que enviamos no seu Whatsapp.";
            }
            toast({
                title: "Boa, seu link de recupera\xe7\xe3o foi enviado!",
                description,
                status: "success",
                isClosable: true,
                position: "top-right"
            });
            router.push(routes/* routes.auth.signIn */._.auth.signIn);
        } catch (error) {
            var _error_response;
            setIsRecoveringAccount(false);
            if (error instanceof es/* ValidationError */.p8) {
                setInputError(error.message);
                return;
            }
            if (((_error_response = error.response) === null || _error_response === void 0 ? void 0 : _error_response.status) === 404) {
                setInputError(accountRecoveryOption === "email" ? "e-mail n\xe3o cadastrado" : "celular n\xe3o cadastrado");
                return;
            }
            toast({
                title: "Ops, ocorreu um erro ao enviar o link de recupera\xe7\xe3o!",
                description: "Recarregue a p\xe1gina e tente novamente.",
                status: "error",
                isClosable: true,
                position: "top-right"
            });
        }
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("form", {
                onSubmit: handleRecoveryAccount,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Header/* Header */.h, {
                        subtitle: !accountRecoveryOption ? "selecione uma op\xe7\xe3o abaixo para enviarmos o c\xf3digo de recupera\xe7\xe3o." : accountRecoveryOption !== "email" ? "digite seu n\xfamero de celular para recuperar sua conta." : "digite seu e-mail para recuperar sua conta."
                    }),
                    accountRecoveryOption ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(FormGroup/* FormGroup */.c, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* Input */.I, {
                                    onChange: handleChangeInput,
                                    variant: "default",
                                    error: inputError,
                                    value: accountRecoveryOption !== "email" ? (0,masks/* maskCellPhone */.JQ)(inputValue) : inputValue,
                                    ...inputOptions
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(FormGroup/* FormGroup */.c, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.z, {
                                    disabledTooltip: inputOptions.placeholder,
                                    isLoading: isRecoveringAccount,
                                    type: "submit",
                                    disabled: !!inputError || (accountRecoveryOption !== "email" ? inputValue.length < 11 : !inputValue),
                                    children: "Recuperar"
                                })
                            })
                        ]
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(AccountRecoveryOptions, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(FormGroup/* FormGroup */.c, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.z, {
                                    onClick: ()=>handleSelectAccountRecoveryOption("whatsapp"),
                                    backgroundColor: "secondary",
                                    textColor: "onSecondary",
                                    children: "Receber pelo Whatsapp"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(FormGroup/* FormGroup */.c, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.z, {
                                    onClick: ()=>handleSelectAccountRecoveryOption("email"),
                                    backgroundColor: "secondary",
                                    textColor: "onSecondary",
                                    children: "Receber por e-mail"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(FormGroup/* FormGroup */.c, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.z, {
                                    onClick: ()=>handleSelectAccountRecoveryOption("sms"),
                                    backgroundColor: "secondary",
                                    textColor: "onSecondary",
                                    children: "Receber por SMS"
                                })
                            })
                        ]
                    })
                ]
            }),
            accountRecoveryOption && /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonLink, {
                onClick: handleChangeAccountRecoveryOption,
                title: "trocar op\xe7\xe3o de recupera\xe7\xe3o",
                icon: io5/* IoOptions */.whI
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* Link */.r, {
                href: routes/* routes.auth.signIn */._.auth.signIn,
                title: "entrar com a minha conta",
                icon: io5/* IoArrowBack */.O8Q
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/pages/forgot-password.tsx


const ForgotPasswordPage = ()=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ForgotPassword, {});
};
var __N_SSP = true;
/* harmony default export */ var forgot_password = (ForgotPasswordPage);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [939,4231,9774,2888,179], function() { return __webpack_exec__(27627); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);